<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <header-add
            class="col-12"
            :btnTitle="$t('production.defects_categories')"
            :typeEvent="1"
            route="/quality/defectscategories/create"
            v-if="isCreate()"
          />
        </div>
        <div v-if="isIndex()">
          <card-header
            :propPagination="pagination"
            @searchedQuery="searchedQuery"
            class="mr-3 mt-4"
          ></card-header>

          <master-table
            :infoTable="queriedData"
            :columns="tableColumns"
            :showColumnStatus="true"
          >
            <template slot="addColumns">
              <table-column-badges
                prop="defects[0].name"
                :label="$t('production.defects')"
                fromData="defects"
                textBadge="name"
              />
              <table-column-badges
                prop="businesses[0].name"
                :label="$t('common_words.associated_companies2')"
                fromData="businesses"
                textBadge="name"
              />
            </template>
            <template slot="addColumnsOperations">
              <table-columns-operations
                v-if="isShow() || isUpdate() || isDelete()"
                @handleView="handleView"
                @handleEdit="handleEdit"
                @handleDelete="handleDelete"
                @handleActivate="handleActivate"
                :canDisable="true"
                :minWidth="110"
              />
            </template>
          </master-table>
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" :propPagination="pagination" />
        <export-tables
          :pdf="{
            filename: `${$t('production.defect_quality')}.pdf`,
            route: 'quality/defectsCategories/pdf',
          }"
          :xls="{
            filename: `${$t('production.defect_quality')}.xlsx`,
            route: 'quality/defectsCategories/excel',
          }"
        />
        <br />
      </card>
      <el-dialog
        v-if="isShow()"
        :title="nameDefectCategorySelected"
        :visible.sync="modals.read"
        width="64%"
        top="2%"
      >
        <div class="card" v-if="rowData">
          <div class="card-body" v-if="rowData">
            <table class="table">
              <tbody>
                <tr class="shadow-sm">
                  <td>
                    <h6>
                      <strong>{{ $t('common_words.category') }}:</strong>
                    </h6>
                    {{ rowData.name }}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('production.defects') }}:</strong>
                    </h6>
                    <span
                      v-for="(defect, index) in rowData.defects"
                      :key="index"
                    >
                      <el-tag :type="defect.deleted_at ? `danger` : `info`">{{
                        defect.name
                      }}</el-tag>
                    </span>
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td>
                    <h6 class="mb-2">
                      <strong>{{ $t('common_words.companies2') }}:</strong>
                    </h6>
                    <span
                      v-for="(business, index) in rowData.businesses"
                      :key="index"
                    >
                      <el-tag type="info">{{ business.name }}</el-tag>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer footer-date-at" v-if="rowData">
            <p class="text-muted">
              <small
                >{{ $t('common_words.created_on') }}:
                {{ rowData.created_at }}</small
              >
            </p>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification';
import Fuse from 'fuse.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import configTable from './defectsCategoriesTable';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  computed: {
    ...configTable().Search,
  },
  data() {
    return {
      defectsCategoriesForm: {
        name: [],
        businesses: [],
        enable: [],
      },
      modelValidations: {
        nombre: {
          required: true,
        },
      },
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
        delete: false,
      },
      searchQuery: '',
      businesses: [],
      nameDefectCategorySelected: 'Categoría',
      rowData: null,
      fuseSearch: null,
      map: null,
    };
  },

  mixins: [
    MixinPermissions,
    mixinMasters,
    MixinExport,
    MixinMenu,
    MixinNotification,
  ],
  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },

    openModal(name) {
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.nameDefectCategorySelected = i18n.t(
        'common_words.record_selected_threepoints'
      );
      this.modals.read = true;
    },

    handleEdit(index, row) {
      this.editForm = Object.assign({}, row);
      this.editForm.name = this.editForm.name;
      sessionStorage.setItem('editForm', JSON.stringify(this.editForm));
      this.$router.push({
        path: '/quality/defectscategories/edit',
      });
    },

    handleDelete(index, row) {
      this.defectsCategoriesForm = row;
      SweetAlert.disable(
        `${i18n.t('common_words.category')}  <br/> "${
          this.defectsCategoriesForm.name
        }"`
      ).then((result) => {
        if (result.value) this.deleteDefectsCategory();
      });
    },

    handleActivate(index, row) {
      this.model = row;
      SweetAlert.default(
        `${i18n.t('sweet_alert.common.enable_category')} "${this.model.name}"?`,
        null,
        i18n.t('common_words.yes_enable'),
        1
      ).then((result) => {
        if (result.value) this.activateDefectsCategory();
      });
    },

    activateDefectsCategory() {
      if (this.isUpdate()) {
        this.showHideLoading(true);
        this.model.route = 'quality/defectsCategories/activate';
        Axios.updateMaster(this.model)
          .then((response) => this.modifyTable(1, this.model.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    deleteDefectsCategory() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.defectsCategoriesForm.route = 'quality/defectsCategories';
        Axios.destroyMaster(this.defectsCategoriesForm)
          .then((response) =>
            this.modifyTable(1, this.defectsCategoriesForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('quality/defectsCategories'),
        Axios.getMasters('businesses/only'),
      ])
        .then((response) => {
          const [response_defectsCategory, response_businesses] = response;
          this.tableData = response_defectsCategory.data.data;
          this.businesses = this.concatAll(response_businesses.data.data);

          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((column) => {
              return column.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('quality');
  },

  destroyed() {
    this.deselectedItemOnMenu('quality');
  },
};
</script>
<style></style>
